import { render } from "./info.vue?vue&type=template&id=1149b274&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=1149b274&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1149b274"]])

export default __exports__